import { render } from "./shiftHandoverReport.vue?vue&type=template&id=196312ff"
import script from "./shiftHandoverReport.vue?vue&type=script&lang=js"
export * from "./shiftHandoverReport.vue?vue&type=script&lang=js"

import "./shiftHandoverReport.vue?vue&type=style&index=0&id=196312ff&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__